import _ from "lodash";
import { globalAssets } from "../../../assets/global/assets";

const assets = {
  ...globalAssets,
  poweredBy: require("../../../assets/wc/images/powered_by_samsung.png"),
};

export default assets;
